import React, { useState } from 'react'
import { transactionTimeStamp } from '../../../utils'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import ModalDialog from '../../layouts/ModalDialog'

const ScheduledExamination = ({exam}) => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  return (
    <>
      <div className='my-5 p-3 bg-white rounded-[8px] bg-opacity-70' >
          <div className='w-full flex items-start justify-between gap-x-4'>
            <div className='w-[80%]'>
                <p className='text-gray-600'>{exam.examination.name}</p>
                <p className='text-xs text-gray-400'>{exam.examination.description}</p>
            </div>
            <div className='w-[20%]'>
                {exam.examScore && <p className='p-2 bg-green-500 rounded bg-opacity-10 font-orbitron text-green-500'>{exam.examScore.toLocaleString()}%</p>}
            </div>
          </div>

          {/* <p className='text-xs text-gray-400 mt-2'>Location:<br /> <span className='text-black font-[500]'>{exam.center ? `${exam.center.name}, ${exam.center.address}, ${exam.center.city}, ${exam.center.state} ${exam.center.state !== 'Abuja' && 'State'}` : exam.location}</span></p>

          <p className='text-xs text-gray-400 mt-2'>Dates:<br /> {exam.examination.dates.map((date, dateIndex)=>(<span key={dateIndex} className='text-black font-[500]'>{date.date}</span>))}</p> */}


          <button onClick={()=>{setDetailsOpen(true)}} className='text-sm flex flex-row items-center gap-x-2 mt-5 text-vcm-purple hover:text-gray-400 transition duration-200'>See details <ArrowIcon className={`w-4 h-4`} /></button> 

          {exam.status === 'WRITTEN' && 
          <p className='text-sm mt-1'>Written on {transactionTimeStamp(exam.dateAdmitted).date} - {transactionTimeStamp(exam.dateAdmitted).time}</p>
          }
      </div>

      <ModalDialog
        shown={detailsOpen} 
        closeFunction={()=>{setDetailsOpen(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Offer Admission`}
        dialogTitle='Examination Details'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <div className='p-4'>
          <p className='text-sm text-gray-600 mb-4'>Please details of the applicant's scheduled examination below</p>
          <p className='text-sm text-gray-600 '>Name: <br /><span className='text-black font-[500]'>{exam.examination.name}</span></p>
          
          <p className='text-sm text-gray-400 mt-2'>Description: <br /><span className='text-black font-[500]'>{exam.examination.description}</span></p>

          <p className='text-sm text-gray-400 mt-2'>Examination mode: <br /><span className='text-black font-[500] capitalize'>{exam.examination.mode.toLowerCase()}</span></p>
          
          <p className='text-sm text-gray-400 mt-2'>Minimum Passing Score: <br /><span className='text-black font-[500]'>{exam.examination.passingScore}%</span></p>
          
          <p className='text-sm text-gray-400 mt-2'>Location:<br /> <span className='text-black font-[500]'>{exam.center ? `${exam.center.name}, ${exam.center.address}, ${exam.center.city}, ${exam.center.state} ${exam.center.state !== 'Abuja' && 'State'}` : exam.location}</span></p>
          
          <p className='text-sm text-gray-400 mt-2'>Examination Dates</p>
          {exam.examination.dates.map((date, dateIndex) => (
            <p key={dateIndex} className='text-sm text-black ml-[10px] mb-1'>{dateIndex + 1}. {transactionTimeStamp(date.date).date} from {date.startTime} to {date.endTime}</p>
          ))}
        </div>
      </ModalDialog>
    </>
  )
}

export default ScheduledExamination